import Vue from 'vue'
import Router from 'vue-router';





const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


const routerOptions = {
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'ind',
            // redirect: {
            //     name: 'home'
            // },
            meta: {
                title: 'Nano AI',
                auth: false,
                menu: 'home'
            },
            component: () => import('@/page/home/home'),
        },
        {
            path: '/home',
            name: 'home',
            redirect: {
                name: 'home'
            },
            // meta: {
            //     title: 'Nano AI',
            //     auth: false,
            //     menu: 'home'
            // },
            // component: () => import('@/page/home/home'),
        },
        {
            path: '/nano',
            name: "nano",
            redirect: {
                name: 'creation-square'
            },
            component: () => import('@/page/index/index'),
            children: [
                {
                    path: 'creation-square',
                    name: 'creation-square',
                    meta: {
                        title: '创作广场',
                        auth: true,
                        menu: 'creation-square'
                    },
                    component: () => import('@/page/creationSquare/creationSquare'),
                },
                {
                    path: 'image-ai-edit',
                    name: 'image-ai-edit',
                    meta: {
                        title: "图片AI编辑",
                        auth: true,
                        menu: 'image-ai-edit'
                    },
                    component: () => import('@/page/imageAiEdit/imageAiEdit'),
                },
                {
                    path: 'image-ai-generate',
                    name: 'image-ai-generate',
                    meta: {
                        title: '图像AI生成',
                        auth: true,
                        menu: 'image-ai-generate'
                    },
                    component: () => import('@/page/imageAiGenerate/imageAiGenerate'),
                },
                {
                    path: 'old-photo-restore',
                    name: 'old-photo-restore',
                    meta: {
                        title: '老照片修复上色',
                        auth: true,
                        menu: 'old-photo-restore'
                    },
                    component: () => import('@/page/oldPhotoRestore/oldPhotoRestore'),
                },
                {
                    path: 'auto-retouch',
                    name: 'auto-retouch',
                    meta: {
                        title: '自动修图',
                        auth: true,
                        menu: 'auto-retouch',
                    },
                    component: () => import('@/page/autoRetouch/autoRetouch'),
                },
                {
                    path: 'quality-enhance',
                    name: 'quality-enhance',
                    meta: {
                        title: '画质增强',
                        auth: true,
                        menu: 'quality-enhance',
                    },
                    component: () => import('@/page/qualityEnhance/qualityEnhance'),
                },
                {
                    path: 'id-photo',
                    name: 'id-photo',
                    meta: {
                        title: '制作证件照',
                        auth: true,
                        menu: 'id-photo',
                    },
                    component: () => import('@/page/idPhoto/idPhoto'),
                },
                {
                    path: 'model-dressing',
                    name: 'model-dressing',
                    meta: {
                        title: '模特换装',
                        auth: true,
                        menu: 'model-dressing',
                    },
                    component: () => import('@/page/modelDressing/modelDressing'),
                },
                {
                    path: 'poster',
                    name: 'poster',
                    meta: {
                        title: '海报翻译',
                        auth: true,
                        menu: 'poster',
                        type: 'poster'
                    },
                    component: () => import('@/page/poster/poster'),
                },
                {
                    path: 'model3d',
                    name: 'model3d',
                    meta: {
                        title: '3D手办',
                        auth: true,
                        menu: 'model3d',
                        type: 'model3d'
                    },
                    component: () => import('@/page/model3d/model3d'),
                },
                {
                    path: 'multi-camera',
                    name: 'multi-camera',
                    meta: {
                        title: '多机位生成',
                        auth: true,
                        menu: 'multi-camera',
                    },
                    component: () => import('@/page/multiCamera/multiCamera'),
                },
                {
                    path: 'multi-pose',
                    name: 'multi-pose',
                    meta: {
                        title: '多种人物姿势生成',
                        auth: true,
                        menu: 'multi-pose',
                    },
                    component: () => import('@/page/multiPose/multiPose'),
                },
                {
                    path: 'order',
                    name: 'order',
                    meta: {
                        title: '订单列表',
                        auth: true,
                        menu: 'order'
                    },
                    component: () => import('@/page/orderView/order'),
                },
                {
                    path: 'bill',
                    name: 'bill',
                    meta: {
                        title: '费用明细',
                        auth: true,
                        menu: 'bill'
                    },
                    component: () => import('@/page/orderView/bill'),
                },
            ]
        }
    ]
}
const router = new Router(routerOptions)

// 导航拦截
router.beforeEach((to, from, next) => {

    next();



});


Vue.use(Router)

export default router
